import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Input, Modal, Select } from "antd";
import { Option } from "antd/lib/mentions";
import { useState } from "react";
import AuthZButton from "../AuthzButton";
import { ReviewTaskAction, sendReviewTaskEvent } from "../matomoClient";
import "./index.css";
import { UserReassign } from "./user-reassign";
import { UserAssign } from "./user-assign";
import { UserNotAssignable } from "./user-not-assignable";

const { TextArea } = Input;

export const ReassignComponent = ({
  isEnable,
  assigneeList,
  reassignHandler,
  taskId,
  isNotAssigned,
  reassignMessage,
  getPopupContainer,
  dataTestId
}) => {
  const popupContainer = getPopupContainer ?? (()=> document.body);
  const [inProgress, setIsInProgress] = useState(false);
  const [visible, setVisible] = useState(false);
  const [assignee, setAssignee] = useState(null);
  const [comments, setComments] = useState(null);
  const modalProps = {
    title: isNotAssigned ? "Assign Task" : "Reassign Task",
    inputTitle: isNotAssigned ? "Select to assign" : "Select to reassign",
  };
  const showModal = () => {
    setVisible(true);
  };

  let okCallback = async () => {
    await reassignHandler(taskId, assignee, comments);
    sendReviewTaskEvent(ReviewTaskAction.ReassignTask);
  };

  function okHandler() {
    setIsInProgress(true);
    okCallback().finally(() => {
      setVisible(false);
      setIsInProgress(false);
    });
  }

  function cancelHandler() {
    setVisible(false);
  }

  return (
    <div className="reassignment-container">
      <AuthZButton
        tooltipPlacement="top"
        tooltipTrigger={isEnable ? ["hover", "click"] : ["hover"]}
        tooltipTitle={reassignMessage}
        tooltipStyle={{ textAlign: "center", fontSize: "x-small" }}
        buttonStyle={{ border: "none", background: "transparent", boxShadow: "none", padding: 0 }}
        buttonDisabled={!isEnable}
        onClick={showModal}
        getPopupContainer={popupContainer}
        dataTestId={dataTestId}
      >
        {!isEnable ? (
          <UserNotAssignable className="user-not-assignable-icon" />
        ) : isNotAssigned ? (
          <UserAssign className="user-assign-icon" />
        ) : (
          <UserReassign className="user-reassign-icon" />
        )}
      </AuthZButton>
      <Modal
        title={modalProps.title}
        visible={visible}
        onOk={okHandler}
        confirmLoading={inProgress}
        onCancel={cancelHandler}
        closable={false}
        maskClosable={false}
        width={450}
        okButtonProps={{ icon: <CheckOutlined />, disabled: !assignee }}
        cancelButtonProps={{ icon: <CloseOutlined />, disabled: inProgress }}
        cancelText="Cancel"
        className={"reassign-modal"}
        getContainer={popupContainer}
      >
        <div className="modal-content-body">
          <div className="modal-content-body-text">
            <div className={"assignee-selector"}>
              <span className={"assignee-selector-label"}>{modalProps.inputTitle}</span>
              <Select
                style={{ width: 230 }}
                allowClear
                placeholder={"Select--"}
                onChange={(value) => setAssignee(value)}
                getPopupContainer={popupContainer}
                showSearch={false}
              >
                {assigneeList?.map((option) => (
                  <Option id={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </div>
            <div className={"reassign-comment"}>
              <span className={"reassign-comment-label"}>Comments</span>
              <TextArea
                maxLength={1000}
                placeholder={"Type here..."}
                onChange={(e) => setComments(e.target.value)}
                className="reassign-comment-textbox"
                style={{
                  width: 230,
                  height: 65,
                  fontSize: 14,
                  marginTop: 14,
                  padding: 10,
                  resize: "none",
                  borderRadius: "2px",
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
